const rules = {
    'ese.required.field': 'required field',
    'ese.required.item': 'required item',
}

const placeholders = {
    'ese.placeholder.please.enter.query.title': 'Please enter query title',
    'ese.placeholder.please.enter.query.content': 'Please enter the query content'
}

const labels = {
    'ese.realname': '真實姓名',
    'ese.account': 'Account',
    'ese.username': 'Username',
    'ese.work.no': 'Work no',
    'ese.email': 'Email',
    'ese.verification.code': 'Verification code',
    'ese.password': 'Password',
    'ese.new.password': 'New password',
    'ese.old.password': 'Old password',
    'ese.confirm.password': 'Confirm password',
    'ese.confirm.new.password': 'Confirm new password',
    'ese.get.verification.code': 'Get verification code',
    'ese.join.factory.date': 'Join factory date',
    'ese.type': 'Type',
    'ese.factory': 'Factory',
    'ese.institutions': 'Institutions',
    'ese.applicant': 'Applicant',
    'ese.business.group': 'Business group',
    'ese.business.office': 'Business office',
    'ese.department': 'Department',
    'ese.phone.number': 'Phone number',
    'ese.extension.number': 'Extension number',
    'ese.position': 'Position',
    'ese.title': 'title',
    'ese.content': 'content',

}

const enJSON = {
    'ese.login': 'Login',
    'ese.logout': 'Logout',
    'ese.home': 'Home',
    'ese.view.profile': 'View profile',
    'ese.system.application.center': 'System Application Center',
    'ese.faqs': 'FAQS',
    'ese.feedback': 'Feedback',
    'ese.sign.in.to.honhai.worker.service': 'Sign in to Honhai worker service',
    'ese.don’t.have.a.xiangxin?': 'Don’t have a xiangxin?',
    'ese.activate.with.employee.ID': 'Activate with employee ID',
    'ese.don’t.have.an.account?': 'Don’t have an account?',
    'ese.already.have.an.account?': 'Already have an account?',
    'ese.register.here': 'Register here',
    'ese.login.here': 'Login here',
    'ese.login.with.account': 'Login with account',
    'ese.remember.me': 'Remember me',
    'ese.want.to.try.to.login.again?': 'Want to try to login again?',
    'ese.recover.password.to.honhai.worker.service': 'Recover password to Honhai worker service',
    'ese.forgot.password?': 'Forgot password?',

    'ese.activation': 'Activation',
    'ese.cancel': 'Cancel',
    'ese.delete': 'Delete',
    'ese.subscribed': 'Subscribed',
    'ese.subscription': 'Subscription',
    'ese.finish': 'Finish',
    'ese.confirm': 'Confirm',
    'ese.submit': 'Submit',
    'ese.close': 'Close',
    'ese.save': 'Save',
    'ese.save.changes': 'Save changes',
    'ese.confirm.send': 'Confirm send',
    'ese.confirm.save': 'Confirm save',
    'ese.send': 'Send',
    'ese.send.out': 'Send out',
    'ese.download': 'Download',
    'ese.export': 'Export',
    'ese.add.to.favorites': 'Add to favorites',
    'ese.fill.in.example': 'Fill in example',
    'ese.clear': 'Clear',

    'ese.not.found': 'Not Found',
    'ese.no.results.found.for': 'No results found for',
    'ese.try.checking.for.typos.or.using.complete.words.': 'Try checking for typos or using complete words.',

    'ese.hello': 'Hello',
    'ese.last.login.time': 'Last Login Time',
    'ese.recently.checked.in': 'Recently checked in',
    'ese.credits.earned': 'Credits earned',
    'ese.recent.consumption': 'Recent consumption',

    'ese.notification.center': 'Notification center',

    'ese.all-in-one.card.area': 'All-in-one card area',
    'ese.cartoon.card1': 'ID card lost',
    'ese.cartoon.card2': 'Application for temporary identification card',
    'ese.cartoon.card3': 'Stationed cadres',
    'ese.cartoon.card4': 'Attendance records',

    'ese.cartoon.card1.item1': 'Download the identification card/all-in-one proximity card/loss/loss of identification card band cutting book',
    'ese.cartoon.card1.item2': 'Submit the cut-off letter to the unit supervisor and unit human resources supervisor for signature',
    'ese.cartoon.card1.item3': 'Payment method: Submit via email or paper to the Taipei Human Resources Card window',
    'ese.cartoon.card1.item4': 'After the identification card is produced, the applicant will be notified to collect and sign for it at the Human Resources Service Headquarters.',

    'ese.cartoon.card2.item1': 'Card holders must be affiliated companies, foreign cadres, consultants, long-term support vendors, and suppliers',
    'ese.cartoon.card2.item2': 'Download the All-in-One Card Temporary Identification Card Application Form',
    'ese.cartoon.card2.item3': 'Submit the application form to the unit supervisor and unit human resources supervisor for approval, and then submit it to Taipei Human Resources for review via email or paper.',
    'ese.cartoon.card2.item4': 'After the identification card is produced, the applicant will be notified to collect and sign for it at the Human Resources Service Headquarters.',

    'ese.cartoon.card3.subtitle1': 'ID card lost',
    'ese.cartoon.card3.subtitle2': 'ID card access control activation',
    'ese.cartoon.card3.subtitle3': 'Hon Hai Card Window',
    'ese.cartoon.card3.item1': 'Please ask your unit assistant to assist you in applying for a temporary card (without printed photo) at the station. This card can only be used temporarily before returning to Taiwan. After returning to Taiwan, you need to apply for a lost identification card and make a new one (please see the lost identification card area for application procedures)',
    'ese.cartoon.card3.item2': `If you want to open second-tier access control (access control other than the main gate) stationed in Taiwan, please contact the unit's human resources/unit assistant first.`,
    'ese.cartoon.card3.item3': 'Central Human Resource provides all-in-one card employee number and serial number to help activate access control rights',
    'ese.cartoon.card3.item4': 'Xu Tingfang 511-3988 (addie.tf.hsu@foxconn.com) Office location: Counter in the 1F lobby of Huyue Factory',

    'ese.cartoon.card4.item1': 'In order to facilitate colleagues to grasp their attendance status in real time, or apply for overtime pay/compassion leave in accordance with regulations, Taipei Human Resources has established a [Taiwan Region Attendance Records] life channel on the Group Trust APP. The functions include: warm attendance reminders, and query of factory attendance records this week. , and important reminder excerpts of attendance/leave/overtime management regulations. For details, please pay attention to the attachment. Group Believe APP',
    'ese.cartoon.card4.item2': '【Attendance Record in Taiwan】Instructions',

    'ese.cartoon.window.label': 'Hon Hai/Hong Zhun all-in-one card window',
    'ese.cartoon.window.value': 'Xu Tingfang 511-3988 (addie.tf.hsu@foxconn.com) Office location: Taipei Human Resources Service Office (2nd floor of Huyao Factory)',

    //

    'ese.labor.and.health.insurance.area': 'Labor and health insurance area',
    'ese.labor.health.title1': 'Apply for labor insurance benefits',
    'ese.labor.health.title2': 'Health insurance related applications',
    'ese.labor.health.title3': 'New Labor Retirement Application',

    'ese.labor.health.t1.subtitle1': 'Maternity benefits',
    'ese.labor.health.t1.subtitle2': 'Injury and illness benefits',
    'ese.labor.health.t1.subtitle3': 'Old age benefits',
    'ese.labor.health.t1.subtitle4': 'Disability benefits',
    'ese.labor.health.t1.subtitle5': 'Death benefit for dependents',

    'ese.labor.health.t2.subtitle1': 'Dependents and relatives',
    'ese.labor.health.t2.subtitle2': 'Surrender for dependents',
    'ese.labor.health.t2.subtitle3': 'Suspension of reinsurance application',
    'ese.labor.health.t2.subtitle4': 'Overseas Medical Refund of National Health Insurance',

    'ese.labor.health.t3.subtitle1': 'Changes in withdrawal of labor withdrawal',
    'ese.labor.health.t3.subtitle2': 'Application form for labor pension',

    'ese.labor.health.t1.s1.description1': 'Application form for maternity benefits',
    'ese.labor.health.t1.s1.description2': 'Maternity Benefit Application Form Template',

    'ese.labor.health.t1.s2.description1': 'Application form for injury and illness benefits',
    'ese.labor.health.t1.s2.description2': 'Injury and Injury Benefit Application Form Template',

    'ese.labor.health.t1.s3.description1': 'Application form for old age benefits',
    'ese.labor.health.t1.s3.description2': 'Old age benefit application form template',

    'ese.labor.health.t1.s4.description1': 'Application form for disability benefits',
    'ese.labor.health.t1.s4.description2': 'Sample application form for disability benefits',

    'ese.labor.health.t1.s5.description1': 'Application form for death benefit of dependents',
    'ese.labor.health.t1.s5.description2': 'Sample application form for death benefit for dependents',

    'ese.labor.health.t2.s1.description1': 'Health insurance transfer application form',
    'ese.labor.health.t2.s1.description2': 'Health Insurance IC Card Application Form',

    'ese.labor.health.t2.s2.description1': 'Application form for transfer of health insurance',

    'ese.labor.health.t2.s3.description1': 'Application form for suspension and reinstatement of health insurance',

    'ese.labor.health.t2.s4.description1': 'Application Form for Medical Refund from National Health Insurance',
    'ese.labor.health.t2.s4.description2': 'Power of attorney',

    'ese.labor.health.t3.s1.description1': 'Self-submit change application form',

    'ese.labor.health.t3.s2.description1': 'Labor pension application form',

    'ese.labor.health.tx.sx.description1': 'Required documents and procedures',
    'ese.labor.health.tx.sx.description2': 'Application conditions and links',

    //

    'ese.my.application': 'My application',

    'ese.all.application': 'All application',
    'ese.all.application.subtitle': 'Aggregate central and peripheral business systems to provide one-stop convenient employee services.',
    'ese.application.management': 'Application management',
    'ese.view.all': 'View all',
    'ese.view.more': 'View more',
    'ese.read.all': 'Read all',
    'ese.read.more': 'Read more',

    'ese.footer.taipei.human.resources.service.office': 'Taipei Human Resources Service Office',
    'ese.footer.service.line': 'service line',

    'ese.th.serial.number': 'No.',
    'ese.th.type': 'Type',
    'ese.th.title': 'Title',
    'ese.th.founder': 'Founder',
    'ese.th.status': 'Status',
    'ese.th.setup.time': 'Create time',
    'ese.th.processor': 'Processor',
    'ese.th.processing.time': 'Processing time',
    'ese.th.operation': 'Operation',

    'ese.unread': 'Unread',
    'ese.archived': 'Archived',

    'ese.find.answers.to.some.frequently.asked.questions.here': 'Find answers to some frequently asked questions here.',
    'ese.question.and.answer': `FAQ's`,

    'ese.none': 'None',

    'ese.client.feedback': 'Client feedback',
    'ese.client.reviews': 'Client reviews',
    'ese.client.testimonials': 'Client testimonials',
    'ese.i.want.feedback': 'Create feedback',

    'ese.employee.comment.request.form': 'Employee Comment Request Form',
    'ese.general': 'General',
    'ese.security': 'Security',

    ...labels,
    ...rules,
};

export default enJSON;
